import axios from 'axios'
import authHeader from "@/services/auth/auth-header";
import config from '@/config.json'

const instance = axios.create({
    baseURL: config.API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        ...authHeader()
    },
})

export default instance;